/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Actionstatussent2Inputs */

const en_actionstatussent2 = /** @type {(inputs: Actionstatussent2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sent to ${i?.count} favourites`)
};

const de_actionstatussent2 = /** @type {(inputs: Actionstatussent2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`An ${i?.count} Favoriten geschickt`)
};

/**
* | output |
* | --- |
* | "Sent to {count} favourites" |
*
* @param {Actionstatussent2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionstatussent2 = /** @type {((inputs: Actionstatussent2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionstatussent2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionstatussent2(inputs)
	return de_actionstatussent2(inputs)
});
export { actionstatussent2 as "actionStatusSent" }